import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown, DBIntField, DBRadioButton, DBTextField } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNotePlanBodyDC extends React.Component {


    radioClicked(val, selected) {
        if (selected && val !== 'GPM' && this.props.plan.PLDISCHARGEPERCGOALSMET) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLDISCHARGEPERCGOALSMET');
        } else if (!selected && val === 'GPM' && this.props.plan.PLDISCHARGEPERCGOALSMET) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLDISCHARGEPERCGOALSMET');
        }
        if (selected && val !== 'OTH' && this.props.plan.PLDISCHARGEOTHER) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLDISCHARGEOTHER');
        } else if (!selected && val === 'OTH' && this.props.plan.PLDISCHARGEOTHER) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLDISCHARGEOTHER');
        }
        if (selected && val === 'PD' && (this.props.plan.PLPROGNOSIS || this.props.plan.PLINDHEP || this.props.plan.PLCOMPLIANCEHEP)) {
            let fields = ['PLPROGNOSIS', 'PLINDHEP', 'PLCOMPLIANCEHEP'];
            this.props.clearFields(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, fields);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <span className={this.props.isValidationRequired ? styles.label_req : styles.label_not_req}>Discharge Reason</span>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='All goals met'
                        className={styles.radio}
                        selectedValue={'GM'}
                        onClick={(selected) => this.radioClicked('GM', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Percent of goals met'
                        className={styles.radio}
                        selectedValue={'GPM'}
                        onClick={(selected) => this.radioClicked('GPM', selected)}
                    />
                    {this.props.gpmSelected &&
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={this.props.plno}
                            field='PLDISCHARGEPERCGOALSMET'
                            className={styles.percent_input}
                        />
                    }
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Did not return to therapy'
                        className={styles.radio}
                        selectedValue={'DNR'}
                        onClick={(selected) => this.radioClicked('DNR', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Poor compliance'
                        className={styles.radio}
                        selectedValue={'PC'}
                        onClick={(selected) => this.radioClicked('PC', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Return to physician'
                        className={styles.radio}
                        selectedValue={'RTP'}
                        onClick={(selected) => this.radioClicked('RTP', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Plateau/Lack of progress'
                        className={styles.radio}
                        selectedValue={'MPR'}
                        onClick={(selected) => this.radioClicked('MPR', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Patient moved'
                        className={styles.radio}
                        selectedValue={'MOV'}
                        onClick={(selected) => this.radioClicked('MOV', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Patient hospitalized or change in medical status'
                        className={styles.radio}
                        selectedValue={'HSP'}
                        onClick={(selected) => this.radioClicked('HSP', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Family request'
                        className={styles.radio}
                        selectedValue={'FRQ'}
                        onClick={(selected) => this.radioClicked('FRQ', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Insurance benefits maximized'
                        className={styles.radio}
                        selectedValue={'NMB'}
                        onClick={(selected) => this.radioClicked('NMB', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Patient deceased'
                        className={styles.radio}
                        selectedValue={'PD'}
                        onClick={(selected) => this.radioClicked('PD', selected)}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Transfer to another clinic'
                        className={styles.radio}
                        selectedValue={'TAC'}
                        onClick={(selected) => this.radioClicked('TAC', selected)}
                    />
                </div>
                {this.props.rtmAvailable && this.props.rtmActive &&
                    <div className={styles.row}>
                        <span className={styles.label_req} />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={this.props.plno}
                            field='PLDISCHARGEREASON'
                            label='Continue with RTM'
                            className={styles.radio}
                            selectedValue={'RTM'}
                            onClick={(selected) => this.radioClicked('RTM', selected)}
                        />
                    </div>
                }
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLDISCHARGEREASON'
                        label='Other'
                        className={styles.radio}
                        selectedValue={'OTH'}
                        onClick={(selected) => this.radioClicked('OTH', selected)}
                    />
                    {this.props.othSelected &&
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={this.props.plno}
                            field='PLDISCHARGEOTHER'
                            className={styles.other_input}
                        />
                    }
                </div>

                {this.props.plan.PLDISCHARGEREASON && this.props.plan.PLDISCHARGEREASON.trim() !== 'PD' &&
                    <span>
                        <div className={styles.row}>
                            <span className={this.props.isValidationRequired ? styles.label_req : styles.label_not_req}>Prognosis if compliant with HEP</span>
                            <DBDropDown
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLPROGNOSIS'
                                className={styles.dropdown}
                                masterEntity='PTMASTERPROGNOSIS'
                                masterEntityKeyColumn='PGNO'
                                masterEntitySort='PGORDER'
                                masterEntityDisplay='PGNAME'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={this.props.isValidationRequired ? styles.label_req : styles.label_not_req}>Patient Independence with HEP</span>
                            <DBDropDown
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLINDHEP'
                                className={styles.dropdown}
                                masterEntity='PTMASTERINDHEP'
                                masterEntityKeyColumn='IHNO'
                                masterEntitySort='IHORDER'
                                masterEntityDisplay='IHNAME'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={this.props.isValidationRequired ? styles.label_req : styles.label_not_req}>Patient compliance with HEP</span>
                            <DBDropDown
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLCOMPLIANCEHEP'
                                className={styles.dropdown}
                                masterEntity='PTMASTERCOMPLHEP'
                                masterEntityKeyColumn='CHNO'
                                masterEntitySort='CHORDER'
                                masterEntityDisplay='CHNAME'
                            />
                        </div>
                    </span>
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let plan = state.entities.notes.PTPLAN[plno];
    let gpmSelected = plan.PLDISCHARGEREASON && plan.PLDISCHARGEREASON.trim() === 'GPM' ? true : false;
    let othSelected = plan.PLDISCHARGEREASON && plan.PLDISCHARGEREASON.trim() === 'OTH' ? true : false;
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isValidationRequired = plan.PLDISCHARGEREASON && plan.PLDISCHARGEREASON.trim() !== 'DNR' ? true : false;
    let rtmAvailable = state.entities.admissions[epno].rtm98975Billable ||
        state.entities.admissions[epno].rtm98977Billable ||
        state.entities.admissions[epno].rtm98980Billable ||
        state.entities.admissions[epno].rtm98981Billable ||
        state.entities.admissions[epno].rtm98985Billable ||
        state.entities.admissions[epno].rtm98979Billable;
    let rtmActive = state.entities.admissions[epno].rtmActive;

    return {
        noteId,
        plno,
        plan,
        gpmSelected,
        othSelected,
        rtmAvailable,
        rtmActive,
        isValidationRequired
    };
}

const connectedPatientCareCenterNotePlanBodyDC = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNotePlanBodyDC);
export { connectedPatientCareCenterNotePlanBodyDC as PatientCareCenterNotePlanBodyDC };

